import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/site";

export const WhatsAppFab = () => (
  <a
    href={WHATSAPP_LINK}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-floating-button"
    aria-label="Chat on WhatsApp"
    className="group fixed bottom-6 right-6 z-[80] flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500 shadow-xl shadow-emerald-900/40 transition-all duration-300 hover:scale-110 hover:bg-emerald-400"
  >
    <MessageCircle className="h-6 w-6 text-white" />
    <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap rounded-full border border-white/10 bg-[#0B192C] px-4 py-2 text-xs font-semibold text-white opacity-0 shadow-xl transition-all duration-300 group-hover:opacity-100">
      Chat with us
    </span>
  </a>
);
